import React, { useState, useEffect } from "react";
import api from "./api.js"; // Assurez-vous que ce chemin est correct
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faPlus,
  faEye,
  faEyeSlash,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";


function Menu() {
  const [menuItems, setMenuItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // Nouvel état pour la confirmation de suppression
  const [newMenu, setNewMenu] = useState({
    id: null,
    name: "",
    description: "",
    image: null,
    price: "",
    available: true,
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [menuToDelete, setMenuToDelete] = useState(null); // L'état pour stocker le menu à supprimer
  const [loader, setLoader] = useState(false); // État pour le loader du bouton de soumission du menu

  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user ? user.role : null;

  const handleShowModal = (item = null) => {
    if (item) {
      setNewMenu({
        id: item.id,
        name: item.name,
        description: item.description,
        image: item.image_path,
        price: item.price,
        available: item.available,
      });
      setImagePreview(item.image_path);
    } else {
      setNewMenu({
        id: null,
        name: "",
        description: "",
        image: null,
        price: "",
        available: true,
      });
      setImagePreview(null);
    }
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleCloseDeleteModal = () => setShowDeleteModal(false); // Fermer le modal de suppression

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewMenu((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewMenu((prevState) => ({
        ...prevState,
        image: file,
      }));

      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmitMenu = (e) => {
    if (e) e.preventDefault();
    setLoader(true); // 1. On démarre le loader

    const formData = new FormData();
    formData.append("name", newMenu.name);
    formData.append("description", newMenu.description || "");
    formData.append("price", newMenu.price);
    formData.append("available", newMenu.available ? 1 : 0);

    if (newMenu.image && newMenu.image instanceof File) {
      formData.append("image", newMenu.image);
    }

    const url = newMenu.id ? `/menuUpdate/${newMenu.id}` : "/menuAdd";

    api
      .post(url, formData)
      .then((response) => {
        console.log("Menu enregistré avec succès :", response.data);
        // Mise à jour de la liste locale... (ton code précédent ici)
        handleCloseModal();
      })
      .catch((error) => {
        if (error.response && error.response.status === 422) {
          console.error("Erreurs Laravel :", error.response.data.errors);
        }
      })
      .finally(() => {
        setLoader(false); // 2. On arrête le loader UNIQUEMENT quand l'API a répondu
      });
  };

  const handleDeleteMenu = () => {
    if (menuToDelete) {
      api
        .delete(`/menuDelete/${menuToDelete.id}`)
        .then((response) => {
          console.log("Menu supprimé avec succès :", response.data);
          setMenuItems(menuItems.filter((item) => item.id !== menuToDelete.id));
          handleCloseDeleteModal();
        })
        .catch((error) => {
          console.error("Erreur lors de la suppression du menu :", error);
        });
    }
  };

  const handleShowDeleteModal = (item) => {
    setMenuToDelete(item);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    api
      .get("/menu")
      .then((response) => {
        setMenuItems(response.data);
      })
      .catch((error) =>
        console.error("Erreur lors de la récupération des données :", error),
      );
  }, []);

  const renderAvailability = (available) => {
    return available ? (
      <span className="badge bg-success">Disponible</span>
    ) : (
      <span className="badge bg-danger">Indisponible</span>
    );
  };

  return (
    <div className="container mt-5 pb-5">
      <div className="d-block d-md-none text-start mb-4">
        <Link
          to="/dashboard"
          className="text-decoration-none fw-bold text-orange"
           style={{color: "#f5721e"}}
        >
          <strong>← Tableau de bord</strong>
        </Link>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 gap-3">
        <h1 className="fw-bold m-0"> Menus</h1>
        {userRole === "1" && (
          <button
            className="btn btn-md text-white shadow-sm d-flex align-items-center"
            style={{ backgroundColor: "#f5721e" }}
            onClick={() => handleShowModal()}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Ajouter un Menu
          </button>
        )}
      </div>

      <div className="card border-0 shadow-sm rounded-3">
        <div className="table-responsive" style={{ maxHeight: "500px" }}>
          <table className="table table-hover align-middle mb-0">
            <thead className="bg-light text-muted small text-uppercase">
              <tr>
                <th className="border-0 ps-4">#</th>
                <th className="border-0">Plat</th>
                <th className="border-0">Description</th>
                <th className="border-0">Prix</th>
                <th className="border-0">Statut</th>
                {userRole === "1" && (
                  <th className="border-0 text-center pe-4">Actions</th>
                )}
              </tr>
            </thead>
            <tbody>
              {menuItems.length > 0 ? (
                menuItems.map((item, index) => (
                  <tr key={item.id}>
                    <td className="ps-4 fw-bold text-muted">{index + 1}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <img
                          src={item.image_path || "/images/default-food.png"}
                          alt={item.name}
                          className="rounded-3 shadow-sm me-3"
                          style={{
                            width: "45px",
                            height: "45px",
                            objectFit: "cover",
                          }}
                        />
                        <span className="fw-semibold text-dark">
                          {item.name}
                        </span>
                      </div>
                    </td>
                    <td className="text-muted small w-25">
                      {item.description}
                    </td>
                    <td className="fw-bold">{item.price} CFA</td>
                    <td>{renderAvailability(item.available)}</td>
                    {userRole === "1" && (
                      <td className="pe-4">
                        <div className="d-flex justify-content-center gap-2">
                          <button
                            className="btn btn-outline-warning btn-sm border-0"
                            onClick={() => handleShowModal(item)}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                          <button
                            className="btn btn-outline-danger btn-sm border-0"
                            onClick={() => handleShowDeleteModal(item)} // Vérifie bien que 'item' est passé ici
                            title="Supprimer ce menu"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-5 text-muted">
                    Aucun menu disponible pour le moment.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* MODAL AJOUTER / MODIFIER */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold">
            {newMenu.id ? "Modifier le Menu" : "Nouveau Plat"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4">
          <form>
            <div className="row g-3">
              <div className="col-md-8">
                <label className="form-label fw-semibold">Nom du Plat</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={newMenu.name}
                  onChange={handleChange}
                  placeholder="Ex: Riz au gras"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold">Prix (CFA)</label>
                <input
                  type="number"
                  className="form-control text-primary fw-bold"
                  name="price"
                  value={newMenu.price}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold">Description</label>
                <textarea
                  className="form-control"
                  rows="3"
                  name="description"
                  value={newMenu.description}
                  onChange={handleChange}
                  placeholder="Ingrédients ou détails..."
                ></textarea>
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold">Image du plat</label>
                <div className="input-group">
                  <input
                    type="file"
                    className="form-control"
                    id="image"
                    onChange={handleImageChange}
                  />
                </div>
                {imagePreview && (
                  <div className="mt-3 position-relative d-inline-block">
                    <img
                      src={imagePreview}
                      alt="Aperçu"
                      className="rounded-3 shadow-sm border"
                      style={{ maxHeight: "150px" }}
                    />
                    <span
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                      style={{ cursor: "pointer" }}
                      onClick={() => setImagePreview(null)}
                    >
                      ×
                    </span>
                  </div>
                )}
              </div>
              <div className="col-12 mt-4">
                <div className="form-check form-switch p-3 bg-light rounded-3 d-flex align-items-center justify-content-between px-5">
                  <label
                    className="form-check-label fw-bold m-0"
                    htmlFor="available"
                  >
                    Disponible immédiatement ?
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="available"
                    style={{ width: "3em", height: "1.5em" }}
                    checked={newMenu.available}
                    onChange={() =>
                      setNewMenu({ ...newMenu, available: !newMenu.available })
                    }
                  />
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="border-0 px-4 pb-4">
          <Button variant="light" className="px-4" onClick={handleCloseModal}>
            Annuler
          </Button>
          <Button
            className="px-5 text-white border-0"
            style={{ backgroundColor: "#f5721e" }}
            onClick={handleSubmitMenu}
          >
            {loader ? (
              <div className="spinner-border" role="status">
                <span className="visually-hidden">En cours...</span>
              </div>
            ) : newMenu.id ? (
              "Enregistrer les modifications"
            ) : (
              "Créer le menu"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* MODAL DE CONFIRMATION DE SUPPRESSION */}
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold text-danger">
            Supprimer le menu ?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <div className="mb-3">
            <FontAwesomeIcon
              icon={faTrash}
              size="3x"
              className="text-danger opacity-25"
            />
          </div>
          <p className="fs-5 mb-1">
            Êtes-vous sûr de vouloir supprimer{" "}
            <strong>{menuToDelete?.name}</strong> ?
          </p>
          <p className="text-muted small">
            Cette action est irréversible et retirera le plat de la carte.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center pb-4">
          <Button
            variant="light"
            className="px-4"
            onClick={handleCloseDeleteModal}
          >
            Annuler
          </Button>
          <Button
            variant="danger"
            className="px-4 shadow-sm"
            onClick={handleDeleteMenu}
          >
            Oui, supprimer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Menu;
